import React, { useCallback, useState } from 'react';
import { Icon } from '@tt/ui';
import PropTypes from 'prop-types';

import Button from '../../../../../components/Button';

import PaymentMethodOptionsModal from './components/PaymentMethodOptionsModal';

import styles from './AddNewPaymentMethod.module.scss';

const AddNewPaymentMethod = ({ children, onAdded, preferredFor, ...props }) => {
  const [open, setOpen] = useState(props.isOpen ?? false);

  const onOpen = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);

  return (
    <div className={styles.container}>
      {children ? (
        React.cloneElement(children, {
          onClick: onOpen,
        })
      ) : (
        <Button tertiary className={styles.button} onClick={onOpen} {...props}>
          <Icon name="plus" />
          New payment method
        </Button>
      )}
      <PaymentMethodOptionsModal
        onAdded={onAdded}
        open={open}
        onClose={onClose}
        preferredFor={preferredFor}
      />
    </div>
  );
};

AddNewPaymentMethod.propTypes = {
  children: PropTypes.node,
  onAdded: PropTypes.func,
  isOpen: PropTypes.bool,
  preferredFor: PropTypes.oneOf([
    'auto_pay',
    'rent_reporting',
    'rent_payments',
  ]),
};

export default AddNewPaymentMethod;
